import { inject } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivateFn, Router } from '@angular/router';
import { AuthService } from '../services/auth.service';
import { HttpClient, HttpParams } from '@angular/common/http';
import { catchError, map, of } from 'rxjs';
import { BASE_URL_SERVICE } from 'src/app/app.module';
import { AccessUnidadInspeccionViewModel } from '../../types/web.services';
import { NotificationService } from '../services/notification.service';

export function ActionEstadoUdInspeccionGuard(): CanActivateFn {
    return (route: ActivatedRouteSnapshot) => {
        let idUnidadInspeccion = route.paramMap.get('idUi');

        if (!idUnidadInspeccion) {
            console.error('You are not allowed to see this page');
            return false;
        }

        const http = inject(HttpClient);
        const baseUrl = inject(BASE_URL_SERVICE);
        const router = inject(Router);
        const authService = inject(AuthService);
        const notificationService = inject(NotificationService);

        let user = authService.getLoggedInUser()!;
        let params = new HttpParams();
        params = params.append('id', idUnidadInspeccion!);

        return http.get<AccessUnidadInspeccionViewModel>(baseUrl + 'api/campanias/main/EstadoUnidadInspeccion/', { params: params }).pipe(
            map(res => {
                const IdSubTipoSolicitud = res.PeriodoCertificaKgs ? 1 : 0;
                if (res && user.getAction(route.data.actionCode, res.IdEstadoUi, res.IdTipoSolicitudCam, IdSubTipoSolicitud).Visible) {
                    return true;
                } else {
                    console.error('You are not allowed to see this page');
                    router.navigate(['/notaccesible']);
                    return false;
                }
            }),
            catchError(() => {
                notificationService.addErrorMessage('Error de autorización');
                router.navigate(['/notaccesible']);
                return of(false);
            }),
        );
    };
}
